import styled from "styled-components";

import { KeyboardTimePicker } from "@material-ui/pickers";
import { FormControlLabel, FormLabel } from "@material-ui/core";

const black = (props) => props.theme.palette.black;
const grey = (props) => props.theme.palette.grey;

export const InputRadioLabel = styled(FormLabel)`
  color: ${black} !important;
  font-weight: 600 !important;
`;

export const InputRadioFormControl = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    color: ${grey};
  }
`;

/* Input Time */
export const StyledInputTime = styled(KeyboardTimePicker)`
  margin-top: 0px !important;
  margin-bottom: 0px !important;
`;
